import React from "react";
import service3 from 'assets/image/service3-image.png'

const Thirdservice = ({click}) => {
  return (
    <div className="col-lg-10 col-md-12 col-12 service-child position-relative" onClick={click}>
      <img className="w-100" src={service3} alt="" />
      <button className="service-btn-3">Assistance administrative </button>
    </div>
  );
};

export default Thirdservice;
